export const GO_TO_MANAGE_PAYEE_PAGE = 'GO_TO_MANAGE_PAYEE_PAGE';
export const goToManagePayeePage = () => ({
	type: GO_TO_MANAGE_PAYEE_PAGE,
});
